import { needsScenePreparation, prepareSceneSimulation } from "../utils/prepareSceneSimulation";
import { sceneShadingPending } from "../components/config/sceneSimulationIssues";
import { detailedShadingEnabled, detailedSceneInputs, detailedSceneKey } from "../utils/detailedShading";
import { sceneShadingKey } from "../components/config/orientationEvidence";
import { prepareSceneInBackground } from "./sceneCalculation";

// Keep saved inputs separate from run-derived shading. Stored-result freshness
// must compare those inputs, not a new measurement timestamp on every run.
export async function productionSceneRequest(config, { projectId, loadModule }) {
  if (detailedShadingEnabled(config)) {
    const module = await loadModule(config.read_module);
    const chars = module?.characteristics || module || {};
    const dimensions = [Number(chars.Length ?? chars.length), Number(chars.Width ?? chars.width)];
    const scene = config.pvDetailedShading.scene;
    // Save layout already validated and built these exact receivers. Check
    // equipment dimensions as well: a catalogue entry can change in place.
    // Old projects and changed layouts still take the full validation path.
    if (dimensions.every(v => Number.isFinite(v) && v > 0) && scene?.version === 1 &&
        scene.planes?.length > 0 && scene.planes.every(p => p.modules?.length > 0) &&
        JSON.stringify(scene.moduleDimensions) === JSON.stringify(dimensions) &&
        JSON.stringify(scene.sourceInputs) === JSON.stringify(detailedSceneInputs(config)) &&
        scene.key === sceneShadingKey(config) + detailedSceneKey(config, dimensions)) {
      return { config };
    }
    return { config: await prepareSceneSimulation(config, { module, projectId }) };
  }
  // Run without the layout's shading, by the user's choice: nothing is
  // worked out on the way.
  if (config?.runWithoutLayoutShading === true) return { config };
  if (!needsScenePreparation(config)) return { config };
  // The calculation stored with the layout ("Calculate shading") is used
  // as it is; only a missing or out-of-date one is worked out here.
  if (!sceneShadingPending(config).length) return { config };
  const module = await loadModule(config.read_module);
  const prepared = await prepareSceneInBackground(config, { module, projectId });
  return {
    config,
    scene_shading: [prepared.pv_design, ...(prepared.orientations || []).slice(1)]
      .map((record) => record.obstacleShading),
  };
}
